import classNames from "classnames";
import * as React from "react";
import "./PopupHeaderButton.scss";

export interface IPopupHeaderButton {
    iconClassName: string;
    className?: string;
    title?: string;
    onClick: () => void;
}

export const PopupHeaderButton = ({ iconClassName, onClick, className, title }: IPopupHeaderButton): JSX.Element => (
    <div className={classNames("popup-header-button", className)} onClick={onClick} title={title || "poga"}>
        <span className={iconClassName} />
    </div>
);
